import React from "react";
import { MdCheck, MdClose, MdFavoriteBorder } from "react-icons/md";
import Button, { IconButton } from "components/button";
import Card from "components/card";
import { InputField, Textarea } from "components/fields";
import IconTile from "./IconTile";

/**
 * Optional prayer request after a survey (campaigns with enablePrayerRequests):
 * a prompt, then an inline form, then a confirmation.
 */
const PrayerRequestCard = ({
  showPhone,
  contact,
  onContactChange,
  request,
  onRequestChange,
  open,
  onOpen,
  onClose,
  submitted,
  submitting,
  onSubmit,
}) => {
  const updateContact = (field) => (e) => onContactChange(field, e.target.value);

  if (submitted) {
    return (
      <Card padding="md" className="items-center text-center">
        <IconTile icon={MdCheck} size="lg" />
        <h2 className="mt-3 text-heading">Prayer Request Received</h2>
        <p className="mt-1 text-sm text-fg-muted">
          Our team will be praying for you. Thank you for sharing with us.
        </p>
      </Card>
    );
  }

  if (!open) {
    return (
      <Card padding="md" className="items-center text-center">
        <IconTile icon={MdFavoriteBorder} size="lg" />
        <h2 className="mt-3 text-heading">Need Prayer?</h2>
        <p className="mt-1 text-sm text-fg-muted">
          We'd be honored to pray for you. Share your request and our team will lift you up in prayer.
        </p>
        <Button fullWidth className="mt-4" onClick={onOpen}>
          Share a Prayer Request
        </Button>
      </Card>
    );
  }

  return (
    <Card padding="md">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <IconTile icon={MdFavoriteBorder} />
          <h2 className="text-heading">Share Your Prayer Request</h2>
        </div>
        <IconButton icon={<MdClose className="h-5 w-5" />} label="Close prayer request" onClick={onClose} />
      </div>

      <div className="flex flex-col gap-3">
        <div className="grid grid-cols-2 gap-3">
          <InputField
            label="First Name"
            name="given-name"
            autoComplete="given-name"
            value={contact.firstName}
            onChange={updateContact("firstName")}
          />
          <InputField
            label="Last Name"
            name="family-name"
            autoComplete="family-name"
            value={contact.lastName}
            onChange={updateContact("lastName")}
          />
        </div>
        <InputField
          label="Email (Optional)"
          type="email"
          name="email"
          autoComplete="email"
          value={contact.email}
          onChange={updateContact("email")}
        />
        {showPhone && (
          <InputField
            label="Phone (Optional)"
            type="tel"
            name="tel"
            autoComplete="tel"
            value={contact.phone}
            onChange={updateContact("phone")}
          />
        )}
        <Textarea
          label="Prayer Request"
          required
          value={request}
          onChange={(e) => onRequestChange(e.target.value)}
          placeholder="Share what's on your heart…"
          rows={4}
        />
      </div>

      <Button
        fullWidth
        className="mt-4"
        onClick={onSubmit}
        disabled={!request.trim()}
        loading={submitting}
      >
        {submitting ? "Submitting…" : "Submit Prayer Request"}
      </Button>
    </Card>
  );
};

export default PrayerRequestCard;
